import React from "react";
import useSecteurEnMasse from "../useSecteurEnMasse";
import LicensePlate from "../../../../common/LicensePlate/LicensePlate";

const SecteurEnMasse = ({ data, onComplete }) => {
  const {
    secteur,
    setSecteur,
    secteurOptions,
    isSubmitting,
    rapport,
    handleSubmit,
    getResultForVehicle,
    getStatusIcon,
  } = useSecteurEnMasse(data, { onComplete });

  return (
    <div className="secteur-en-masse">
      <div className="modal-header">
        <h4 className="modal-title">
          <i className="fas fa-pen mr-2"></i>
          Modifier le secteur en masse ({data.length} véhicules)
        </h4>
      </div>

      <div className="modal-body">
        <form onSubmit={handleSubmit} className="mb-4">
          <div className="card">
            <div className="card-body">
              <h6 className="card-title mb-3">
                <i className="fas fa-cogs mr-2"></i>
                Secteur à appliquer
              </h6>
              <div className="form-group">
                <select
                  className="form-control"
                  value={secteur}
                  onChange={(e) => setSecteur(e.target.value)}
                  disabled={isSubmitting}
                >
                  <option value="">Sélectionner un secteur...</option>
                  {secteurOptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || !secteur}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Application en cours...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check mr-2"></i>
                    Appliquer le secteur
                  </>
                )}
              </button>
            </div>
          </div>
        </form>

        {rapport && (
          <div
            className={`alert ${
              rapport.echecs.length > 0 ? "alert-warning" : "alert-success"
            } mb-3`}
          >
            {rapport.succes.length} véhicule
            {rapport.succes.length > 1 ? "s" : ""} mis à jour
            {rapport.echecs.length > 0 && (
              <>
                , {rapport.echecs.length} échec
                {rapport.echecs.length > 1 ? "s" : ""}
              </>
            )}
          </div>
        )}

        <div className="card">
          <div className="card-body">
            <h6 className="card-title mb-3">
              <i className="fas fa-table mr-2"></i>
              Véhicules sélectionnés
            </h6>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th scope="col">Statut</th>
                    <th scope="col">Véhicule</th>
                    <th scope="col">Client</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    const result = getResultForVehicle(item.vehicleId);

                    return (
                      <tr key={item.vehicleId}>
                        <td className="text-center">
                          {getStatusIcon(result)}
                        </td>
                        <td>
                          <div>
                            <strong>
                              {item.vehicleInfo.marque}{" "}
                              {item.vehicleInfo.modele}
                            </strong>
                            <br />
                            <LicensePlate
                              value={item.vehicleInfo.immatriculation}
                              size="sm"
                            />
                            {result?.status === "error" && (
                              <div className="text-danger">
                                <small>{result.raison}</small>
                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <small className="text-xs">
                            {item.vehicleInfo.client || "N/A"}
                          </small>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecteurEnMasse;
